import {
  Button,
  CircularProgress,
  createStyles,
  makeStyles,
  Theme,
  ButtonProps,
} from "@material-ui/core";
import clsx from "clsx";
import React from "react";

import { useButtonStyles } from "@/features/common/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: 6,
      minWidth: 0,
      width: 30,
      height: 30,
      borderRadius: "50%",
    },
  }),
);

type CircleIconButtonProps = {
  loading: boolean;
  active: boolean;
  isOnOverlay?: boolean;
};

export const CircleIconButton: React.FC<
  CircleIconButtonProps & Omit<ButtonProps, "color" | "variant" | "className">
> = (props) => {
  const { loading, active, children, disabled, isOnOverlay, ...rest } = props;
  const classes = useStyles();
  const buttonClasses = useButtonStyles();

  return (
    <Button
      {...rest}
      disabled={loading || disabled}
      className={clsx(classes.root, isOnOverlay && buttonClasses.outlinedWhite)}
      color="default"
      variant="outlined"
    >
      {loading ? <CircularProgress size={15} color="inherit" /> : children}
    </Button>
  );
};
